module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ea253b4d59fb4421746a7206f13213fe.jpg";